import type { useTranslation } from 'react-i18next';
import type { BandRole } from '@/map/spectral';
import type { RasterMeta } from '@/map/useRasterMeta';

type T = ReturnType<typeof useTranslation<'reports'>>['t'];

/** A band's name in the page's language, with the file's own name beside it when that says something else. */
export function bandLabel(t: T, meta: RasterMeta | undefined, role: BandRole): string {
  const index = meta?.band_roles?.[role];
  const name = index ? meta?.band_names?.[index - 1] : null;
  const label = t(`multispectral.bands.${role}`);
  return name && name.toLowerCase() !== label.toLowerCase() ? `${label} (${name})` : label;
}
